import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_ALL_USER_IDS: () => ({}),
    API: {
      GET_ALL_USER_IDS: apiResourceActionCreator('userIds')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getAllUserIds`, authToken, action.admin.api.getAllUserIds)

function* getAllUserIds(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getAllUserIds',
  action: action,
  sagas: getAllUserIds,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingUser: true
    }),
    success: (state, action) => {
      return ({
        ...state,
        isFetchingUser: false,
        userIds: action.payload.userIds
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingUser: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getAllUserIds.js